function calcGeometry(imageZoom: number, image: Size, container: HTMLElement) {
  const imageSize = {
    width: image.width / imageZoom,
    height: image.height / imageZoom,
  }
  const containerBox = container.getBoundingClientRect()
  const aspectRatio = imageSize.width / imageSize.height
  const containedSize = {
    width: Math.min(containerBox.width, containerBox.height * aspectRatio),
    height: Math.min(containerBox.height, containerBox.width / aspectRatio),
  }
  const imageScale = Math.min(containerBox.width / imageSize.width, containerBox.height / imageSize.height)

  return { containedSize, imageScale }
}

export function normalizedCoordsToImageCoordSpace(normalized: Point, imageZoom: number, image: Size, container: HTMLElement): Point {
  const { containedSize, imageScale } = calcGeometry(imageZoom, image, container)
  return {
    x: ((normalized.x + 1) * containedSize.width) / (2 * imageScale),
    y: ((normalized.y + 1) * containedSize.height) / (2 * imageScale),
  }
}

export function imageCoordSpaceToNormalizedCoords(
  point: Point,
  imageZoom: number,
  image: Size,
  container: HTMLElement,
  { dimensions: panZoomTransform }: PanZoomTransform
): Point {
  const { containedSize, imageScale } = calcGeometry(imageZoom, image, container)
  const normalized = {
    x: (point.x * 2 * imageScale) / containedSize.width - 1,
    y: (point.y * 2 * imageScale) / containedSize.height - 1,
  }
  if (!panZoomTransform) return normalized

  const { scale: zoom, center } = panZoomTransform
  const pan = {
    x: (center.x / containedSize.width) * 2 - 1,
    y: (center.y / containedSize.height) * 2 - 1,
  }
  return applyPanZoom(normalized, pan, zoom)
}

export function applyPanZoom(pt: Point, pan: Point, zoom: number): Point {
  return { x: (pt.x - pan.x) * zoom, y: (pt.y - pan.y) * zoom }
}

export function removePanZoom(pt: Point, pan: Point, zoom: number): Point {
  return { x: pt.x / zoom + pan.x, y: pt.y / zoom + pan.y }
}
